var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236-477q0 59 22 102t60 75l24 15v-70q0-15 10-25t26-10q15 0 25 10t10 25v163q0 20-13.5 33.5T366-145H204q-15 0-25-10.5T169-181q0-15 10-25t26-10h69l-5-5q-65-56-96.5-117.5T141-477q0-102 56-185.5T345-787q16-7 30 3t19 28q5 18-3.5 35T366-695q-60 32-95 90.5T236-477Zm488-6q0-44-22.5-90T645-655l-23-20v70q0 15-10.5 25T586-570q-15 0-25.5-10.5T550-606v-162q0-20 13.5-33.5T598-815h161q15 0 25.5 10t10.5 25q0 15-10.5 25.5T759-744h-71l6 7q62 58 93.5 125T819-483q0 101-54 183.5T620-174q-16 8-31.5-1.5T568-204q-6-18 2.5-35t25.5-26q59-31 93.5-90T724-483Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSync);
export default __webpack_public_path__ + "static/media/custom-sync.4b993f3d72a81415d3f23fdf4b6d051b.svg";
export { ForwardRef as ReactComponent };